import React, { useCallback, useEffect, useRef, useState } from "react";

import Link from "@components/_Revamp/Link";
import Text from "@components/Text";
import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { useDispatch } from "react-redux";
import { themeDefault } from "src/theme-revamp";
import { isEmpty } from "lodash";
import { postSavingMyInfo } from "@api/index";
import Button from "@components/_Revamp/Button";
import Bullet from "@components/_Revamp/Bullet";
import { useHistory } from "react-router-dom";
import { useAvivaSelector } from "@redux/hook";
import useForm from "@utils/useForm";
import { validateDeclaration } from "./service";
import { Helpers } from "@utils/helpers";
import {
  completeDeclarationStep,
  completeStep,
  updateDeclaration,
} from "@redux/slices/MLTC_R3/step4Slice";
import { IMyInfoQuestionRequest } from "@models/MyInfoRequest.model";
import { DeclarationForm } from "@models/MLTC_R3/Declaration.model";
import { GAAviva, MLTC_R3_JOURNEY_NAME } from "@utils/gaAvivaR3";
import Modal from "@components/_Revamp/Modal";
import { TitleAndDescription } from "@components/_Revamp/TitleAndDescription";
import { ActionButton } from "@components/_Revamp/ActionButton";
import Stepper from "@components/_Revamp/Stepper";
import { Step } from "@components/_Revamp/Stepper/Stepper";
import BottomSheet from "@components/_Revamp/BottomSheet";
import {
  DECLARATION_MLTC,
  PRODUCT_SUMMARY_MLTC,
  TERMS_AND_CONDITIONS_MLTC,
} from "@static/staticConstents";

const Container = styled.div`
  position: relative;
  padding: 0 100px;
  margin: 0 auto;
  max-width: 1230px;
  display: block;
  flex-wrap: wrap;
  @media screen and (max-width: 1280px) {
    padding: 0 24px;
  }
  @media screen and (max-width: 768px) {
    padding: 0 24px;
  }
`;
const DeclarationBulletsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
  @media screen and (max-width: 768px) {
    margin: 0;
  }
`;
const HeaderTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  color: #434343;
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

const FormContainer = styled.div<FormHeaderContainerProps>`
  opacity: 0;
  -webkit-transition: opacity 0.5s ease-in;
  -moz-transition: opacity 0.5s ease-in;
  -o-transition: opacity 0.5s ease-in;
  -ms-transition: opacity 0.5s ease-in;
  transition: opacity 0.5s ease-in;
  transition: all 0.2s ease;
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  margin: 200px auto 100px auto;
  max-width: 327px;

  margin: 200px auto 100px auto;

  @media screen and (min-width: 768px) {
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
    margin: 200px auto 50px auto;
  }
  @media screen and (min-width: 1024px) {
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
    margin: ${(props) => (props.margin ? props.margin : "100px auto")};
  }
`;
const FormHeaderContainer = styled.div`
  display: block;
  margin-bottom: 64px;
  @media screen and (max-width: 768px) {
  }
`;
const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: block;
  margin: 0 ${(props) => props.marginHorizontal};
  margin: 0;
  margin-bottom: 16px;
  @media screen and (max-width: 768px) {
    padding: 0 20px;
    margin-bottom: 12px;
  }
`;
const FormHeaderDescriptionContainer = styled.div`
  display: block;
  margin: 0 50px;
  @media screen and (max-width: 768px) {
    padding: 0;
    margin: 0;
  }
`;
const FormButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 64px;
  column-gap: 24px;
  @media screen and (max-width: 768px) {
    column-gap: 0;
    row-gap: 10px;
    margin-top: 80px;
    flex-direction: column;
    align-items: center;
  }
`;

const HeaderDescriptionCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  color: #8a8988;
  @media screen and (max-width: 768px) {
    font-weight: 400;
  }
`;

const DeclarationParagraph = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22.4px;
  color: #434343;
`;

const container_default_css = css`
  margin-bottom: 0px;
`;

const title_default_css = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  @media screen and (max-width: 768px) {
    width: unset;
    font-size: 16px;
  }
`;

export interface MessageNoteProps {
  color?: string;
}
export interface ModalContainerProps {
  display?: boolean;
}

export interface StepInterface {
  label: string;
  isCurrentStep: boolean;
}
export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
}
export interface FormHeaderContainerProps {
  margin?: string;
  maxWidth?: string;
}

// const ProductSummaryURL = "./docs/mltc/Product-Summary.pdf";
// const PolicyTermsConditionsURL = "./docs/mltc/Policy-Contract.pdf";
// const ProductSummaryURL = "https://singlife.com/content/dam/public/sg/documents/disability-insurance/singlife-careshield-standard-and-plus-and-eldershield-standard-and-plus/product-summary.pdf";
// const PolicyTermsConditionsURL = "https://singlife.com/content/dam/public/sg/documents/disability-insurance/singlife-careshield-standard-and-plus-and-eldershield-standard-and-plus/policy-contract.pdf";
// const DeclarationDocumentURL = "https://singlife.com/content/dam/public/sg/documents/disability-insurance/singlife-careshield-standard-and-plus-and-eldershield-standard-and-plus/declaration.pdf";

function Declaration() {
  const history = useHistory();

  const dispatch = useDispatch();
  const basicDetails = useAvivaSelector(
    (state) => state.mltcR3Step1.basicDetails
  );
  const transactionId = useAvivaSelector((state) => state.mltcR3Step2.transactionId);
  const gioDeclaration = useAvivaSelector(state => state.mltcR3Step2.gioDeclaration);
  const retrievedMyInfo = useAvivaSelector(
    (state) => state.mltcR3Step4.retrievedMyInfo
  );
  const myInfoStepCompleted = useAvivaSelector(
    (state) => state.mltcR3Step4.isMyInfoStepCompleted
  );
  const campaignDetail = useAvivaSelector(
    (state) => state.loading.campaignDetail
  );
  const declaratinInitialValue = useAvivaSelector(
    (state) => state.mltcR3Step4.declaration
  );
  const [declarationState, setDeclarationState] = useState<any>();
  const [isDisagreeModalShow, setDisagreeModalShow] = useState<boolean>(false);

  const [aaTracking, setAATracking] = useState<string[]>([]);

  const [isProceed, setIsProceed] = useState<boolean>(false);
  const [isPreviousCompleted, setPreviousCompleted] =
    useState<boolean>(myInfoStepCompleted);
  const analyticUrlParams = useAvivaSelector(
    (state) => state.urlAnalytic.param
  );
  const paramCC = campaignDetail?.campaignCode
    ? `?cc=${campaignDetail.campaignCode}`
    : "";
  const analyticParam = Helpers.getUrlAnalyticParams(
    paramCC !== "",
    analyticUrlParams
  );
  // const isReAttempt = useRef(false)

  const myInfoDeclaratinoRef = useRef<null | HTMLDivElement>(null);

  const {
    errors,
    handleChange,
    formValid,
    values: declarationValues,
    patchValue: patchValueDeclaration,
  } = useForm(
    new DeclarationForm(declaratinInitialValue),
    () => {},
    validateDeclaration
  );
  const [campaignCode, setCampaignCode] = useState<string>("MLO1");
  const qrClientDetails = useAvivaSelector(
        (state) => state.mltcR3Step5.qrClientDetails,
      );
  const validQRClient = qrClientDetails?.status === "SUCCESS";

  const stepsList: Step[] = [
    {
      label: "Basic Info",
      isCurrentStep: false,
      path: "/mltc/lets-get-started",
      disabled: validQRClient
    },
    {
      label: "Quote",
      isCurrentStep: false,
      path: "/mltc/choose-plan",
    },
    {
      label: "Health Declaration",
      isCurrentStep: false,
      path: "/mltc/health",
      disabled: gioDeclaration === "GIO",
    },
    {
      label: "Start Application",
      isCurrentStep: true,
      path: "/mltc/my-info",
    },
    {
      label: "Review & Payment",
      isCurrentStep: false,
      path: "/mltc/review",
    },
  ];

  const onClickDisagreeAll = () => {
    patchValueDeclaration({
      summary: false,
      term: false,
      declaration: false,
      required1: false,
    });
    setIsProceed(true);
    setDisagreeModalShow(true);
  };
  const onClickAgreedAll = () => {
    patchValueDeclaration({
      summary: true,
      term: true,
      declaration: true,
      required1: true,
    });
    setIsProceed(true);
  };
  const convertConsent = (values: any) => {
    console.log("values[sms]", values["sms"]);
    console.log("values[email]", values["email"]);
    console.log("values[phone]", values["phone"]);
    console.log("values[mail]", values["mail"]);
    let customerConsent = `SMS,${values["sms"] ? "Y" : "N"}|Phone,${
      values["phone"] ? "Y" : "N"
    }|Mail,${values["mail"] ? "Y" : "N"}|EMail,${values["email"] ? "Y" : "N"}`;
    return customerConsent;
  };
  const convertDeclaration = (values: DeclarationForm) => {
    const convertValue = (value: boolean | undefined) =>
      value === true ? "Y" : "N";

    // NOTE : R3 do not have required2 and required 3, So manually set to TRUE
    // require2 checkbox =  I am purchasing the plan without any advice from a financial adviser representative and I take responsibility to ensure that this plan suits my needs.
    // require3 checkbox =  I am physically present in Singapore at the time of this application submission.

    return (
      `2,${convertValue(values.summary)}|` +
      `16,${convertValue(values.term)}|` +
      `17,${convertValue(values.declaration)}|` +
      `18,${convertValue(values.required1)}|` +
      `19,${convertValue(true)}|` +
      `20,${convertValue(true)}|`
    );
  };
  const updateMyInfo = async () => {
    console.log("updateMyInfo()", declarationValues);
    const id = retrievedMyInfo?.id || 0;
    console.log("declaration retrievedMyInfo?.id", retrievedMyInfo?.id);
    const declaration = convertDeclaration(declarationValues);
    let customerConsent = convertConsent(declarationValues);
    console.log("customerConsent", customerConsent);

    const params = new URLSearchParams(window.location.href.split("?")[1]);
    const inject = params.get("inject");
    const payload: IMyInfoQuestionRequest = {
      id,
      customerConsent,
      declaration,
      transactionId
    };
    payload.smokingStatus = "No";

    await postSavingMyInfo(payload).then(
      () => {
        dispatch(completeDeclarationStep(true));
        history.push(
          "/mltc/review" +
            paramCC +
            (inject ? "?inject=true" : "") +
            analyticParam
        );
      },
      (error) => {
        console.error(error);
        history.push("/mltc/something-wrong");
        // history.push('/mltc/review' + paramCC + (inject ? '?inject=true' : '') + analyticParam);
        //   if(!isReAttempt){
        //  setTimeout(()=>{
        //    updateMyInfo();
        // },1000)}
      }
    );
  };
  const trackOnLoad = useCallback(
    (formName: string): void => {
      if (!aaTracking.includes(formName)) {
        setAATracking([...aaTracking, formName]);
        const GA = GAAviva.getInstance();
        let { form, page } = GA.digitalData;
        form.name = formName;

        // QB-AA-Tracking fix: step 14 ("Declaration") of the journey.
        page.journeyName = MLTC_R3_JOURNEY_NAME;
        page.stepName = "Declaration";
        page.stepNumber = "14";

        GA.trackPageLoad({ form, page });
      }
    },
    [aaTracking]
  );

  useEffect(() => {
    setIsProceed(false);
    patchValueDeclaration(declaratinInitialValue);
    const params = new URLSearchParams(window.location.href.split("?")[1]);
    const inject = params.get("inject");
    console.log("QnB ➤ useEffect() ➤", {
      "step1Slice ➤ basicDetails": basicDetails,
      campaignDetail,
      params,
    });
    if (campaignDetail) {
      setCampaignCode(campaignDetail?.code);
    }
    trackOnLoad("mltc_declaration_form");
  }, [
    basicDetails,
    campaignDetail,
    declaratinInitialValue,
    patchValueDeclaration,
    trackOnLoad,
  ]);

  useEffect(() => {
    setDeclarationState(declarationValues);
    if (
      declarationValues.summary ||
      declarationValues.term ||
      declarationValues.declaration ||
      declarationValues.required1
    ) {
      if (isProceed) {
        dispatch(updateDeclaration(declarationValues));
        dispatch(completeStep(true));
        updateMyInfo();
        setIsProceed(false);
      }
    }
  }, [isProceed, declarationValues, patchValueDeclaration]);

  useEffect(() => {
    if (myInfoStepCompleted) {
      if (myInfoDeclaratinoRef.current) {
        isPreviousCompleted
          ? (myInfoDeclaratinoRef.current.style.opacity = "1")
          : (myInfoDeclaratinoRef.current.style.opacity = "0");
      }
    } else {
      history.goBack();
    }
  }, [myInfoStepCompleted, isPreviousCompleted]);

  const gotoContact = useCallback(() => {
    // check campaign flow
    if (campaignDetail?.code === "LUB1") {
      setDisagreeModalShow(true);
    } else {
      let param = paramCC !== "" ? paramCC + "&variant=true" : "?variant=true";
      history.push("/mltc/contact-form" + param);
    }
  }, [history, campaignDetail]);

  return (
    <Container>
      <FormContainer
        maxWidth={"588px"}
        margin={"150px auto 50px "}
        ref={myInfoDeclaratinoRef}
      >
        <FormHeaderContainer>
          <FormHeaderTitleContainer marginHorizontal={"100px"}>
            <Text
              theme={themeDefault}
              align={"center"}
              className={HeaderTitleCss}
            >
              Declaration
            </Text>
          </FormHeaderTitleContainer>
          <FormHeaderDescriptionContainer>
            <Text theme={themeDefault} className={HeaderDescriptionCss}>
              Please ensure that you have clicked on the links and read the
              documents fully before selecting the checkboxes.
            </Text>
          </FormHeaderDescriptionContainer>
        </FormHeaderContainer>

        <DeclarationBulletsContainer>
          <Bullet>
            <Text theme={themeDefault} className={DeclarationParagraph}>
              I have read and understood the{" "}
              <Link
                theme={themeDefault}
                target="_blank"
                rel="noopener noreferrer"
                url={PRODUCT_SUMMARY_MLTC}
                text={"Product Summary"}
              />{" "}
              including any coverage exclusion stated in the Product Summary.
            </Text>
          </Bullet>
          <Bullet>
            <Text theme={themeDefault} className={DeclarationParagraph}>
              I have downloaded, fully read and understood the{" "}
              <Link
                theme={themeDefault}
                target="_blank"
                rel="noopener noreferrer"
                url={TERMS_AND_CONDITIONS_MLTC}
                text={"Policy Terms & Conditions"}
              />
              .
            </Text>
          </Bullet>
          <Bullet>
            <Text theme={themeDefault} className={DeclarationParagraph}>
              I have read and agreed to the statements described in the{" "}
              <Link
                theme={themeDefault}
                target="_blank"
                rel="noopener noreferrer"
                url={DECLARATION_MLTC}
                text={"Declaration Document"}
              />
              .
            </Text>
          </Bullet>
          <Bullet>
            <Text theme={themeDefault} className={DeclarationParagraph}>
              I have completed and disclosed fully and truthfully all the
              information requested for in this application.
            </Text>
          </Bullet>
          <Bullet>
            <Text theme={themeDefault} className={DeclarationParagraph}>
              I am purchasing this plan without any advice from a financial
              adviser representative and I take responsibility to ensure that
              this plan suits my needs.
            </Text>
          </Bullet>
          <Bullet>
            <Text theme={themeDefault} className={DeclarationParagraph}>
              I understand that I will receive my policy, any endorsements and communications electronically once they are ready. I understand that I may log on to MySinglife to opt for my preferred document option and may switch between e-documents and printed documents.
            </Text>
          </Bullet>
        </DeclarationBulletsContainer>

        <FormButtonContainer>
          <Button
            onClick={onClickDisagreeAll}
            width={"180px"}
            variant={"secondary"}
            theme={themeDefault}
            label={"I do not agree"}
          ></Button>
          <Button
            onClick={onClickAgreedAll}
            width={"180px"}
            variant={"default"}
            theme={themeDefault}
            label={"Agree to all"}
          ></Button>
        </FormButtonContainer>
      </FormContainer>

      <Stepper steps={stepsList}></Stepper>

      <Modal show={isDisagreeModalShow}>
        <TitleAndDescription
          title="Are you sure?"
          description="By not agreeing with the above, we will get a Financial Adviser Representative (FAR) to follow up with you on this purchase journey"
          margin="0 0 80px 0"
        />
        <ActionButton
          actionType="confirm"
          closeLabel="No"
          confirmlabel="Yes"
          width="180px"
          onClose={() => setDisagreeModalShow(false)}
          onConfirm={gotoContact}
        />
      </Modal>
      <BottomSheet />
    </Container>
  );
}

export default Declaration;
